exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-title[data-v-33d5f1b4] {\n  padding: 16px 16px 0px 16px;\n}\n[data-v-33d5f1b4] .v-divider {\n  border-color: gray;\n  margin: 0px;\n}\n", ""]);

// exports
